<template>
  <nav class="tabbar" aria-label="Primary">
    <button type="button" class="tab" :class="{ active: isActive(assetsRoutes) }" @click="go('Assets')">
      <v-icon size="22">mdi-cube-outline</v-icon>
      <span>Assets</span>
    </button>

    <button v-if="can(Permissions.AnomalyView)" type="button" class="tab"
      :class="{ active: isActive(findingsRoutes) }" @click="go('AnomalyManagementOrg')">
      <span class="tab-icon-wrap">
        <v-icon size="22">mdi-alert-outline</v-icon>
        <span v-if="pendingCount > 0" class="tab-dot"></span>
      </span>
      <span>Findings</span>
    </button>

    <button type="button" class="tab" :class="{ active: isActive(accountRoutes) }" @click="go('Profile')">
      <v-icon size="22">mdi-account-outline</v-icon>
      <span>Account</span>
    </button>
  </nav>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { Permissions } from '@/constants/permissions';
import { usePermissions } from '@/composable/usePermissions';

defineOptions({ name: 'MobileTabBar' });

defineProps({
  pendingCount: { type: Number, default: 0 },
});

const route = useRoute();
const router = useRouter();
const { can } = usePermissions();

const assetsRoutes = ['Assets', 'AssetLanding'];
const findingsRoutes = ['AnomalyManagementOrg', 'AnomalyManagement'];
const accountRoutes = ['Profile'];

const isActive = (names) => names.includes(route.name);
const go = (name) => { if (route.name !== name) router.push({ name }); };
</script>

<style scoped>
.tabbar {
  position: fixed;
  left: 0; right: 0; bottom: 0;
  z-index: 40;
  height: calc(64px + env(safe-area-inset-bottom, 0px));
  padding: 6px 12px calc(6px + env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
  display: flex;
  background: #141a1f;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 -6px 18px rgba(0, 0, 0, 0.35);
}

.tab {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  background: none;
  border: none;
  color: #8aa0aa;
  font: inherit;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.tab.active { color: var(--duallo-accent); }

.tab-icon-wrap { position: relative; display: inline-flex; }
.tab-dot {
  position: absolute; top: -1px; right: -3px;
  width: 8px; height: 8px; border-radius: 50%;
  background: #f0a623; border: 1.5px solid #141a1f;
}
</style>
